import { getMerchantInfo } from '@util'

/**
 * 轮询事件保持多tab页只有一个执行
 */
export class SingleLoop {
  /**
   * @param {string} storageKey - 用来将数据储存到localStorage的key
   * @param {function} loopFn - 获取数据的异步(async)函数 需要返回promise
   * @param {number} ms - 轮询时间
   * @param {function} callback - 轮询获取到数据后的回调
   */
  constructor(storageKey, loopFn, ms, callback) {
    const isMainMerchant = getMerchantInfo().shop_type == 5
    this.key = storageKey + (isMainMerchant ? '_main' : '') // localStorage中储存数据的key
    this.loopFn = loopFn // 事件
    this.ms = ms // 时间间隔 ms
    this.callback = callback
    this.otherTabIsGettingData = false // 其他tab正在请求数据
    this.timer = null
  }

  /** 启动轮询 */
  start() {
    // 监听localStorage变化
    window.addEventListener('storage', this.onStorageChange)
    this.loop()
  }

  stop() {
    window.removeEventListener('storage', this.onStorageChange)
    clearTimeout(this.timer)
  }

  onStorageChange = ({ key }) => {
    if (key === this.key) {
      const storage = this.getDataFromStorage()
      this.otherTabIsGettingData = true
      // console.log('监听到数据变化：', this.key, data, '停止当前页面的数据获取')
      this.callback(storage.data)
    }
  }

  loop() {
    this.getData()
    this.timer = setTimeout(() => {
      this.loop()
    }, this.ms)
  }

  /** 从接口或localStorage中取数据 */
  async getData() {
    let data
    if (this.otherTabIsGettingData) {
      // 已有tab在请求数据
      const storageData = this.getDataFromStorage()
      const now = +new Date()
      const storageDataTime = storageData.time || 0
      if (now - storageDataTime > this.ms + 1000) {
        // 旧数据已过期，可能请求数据的tab已被关闭，在当前页面开始请求数据
        // console.log('数据已过期', this.key, now - storageData.time, '重新启动')
        this.otherTabIsGettingData = false
        data = await this.setDataToStorage()
      } else {
        data = storageData.data
      }
    } else {
      data = await this.setDataToStorage()
      // console.log(this.key, '没有其他页面请求数据，执行http请求')
    }
    this.callback(data)
  }

  getDataFromStorage() {
    return JSON.parse(localStorage.getItem(this.key) || '{}')
  }

  /** 从接口获取数据并存入到localStorage */
  async setDataToStorage() {
    const data = await this.loopFn()
    const value = JSON.stringify({
      data,
      time: +new Date()
    })
    localStorage.setItem(this.key, value)
    return data
  }
}
